import { createContext, useState } from "react";

const AuthContext = createContext<AuthContext | null>(null);

export const AuthProvider = ({ children } : { children:React.ReactNode}) => {
    const [auth, setAuth] = useState<Auth>({
        data: null,
        status: null
    });

    const storedPersist = sessionStorage.getItem('persist');
    const parsedPersist = Boolean(storedPersist)
    const [persist, setpersist] = useState(parsedPersist);

    return (
        <AuthContext.Provider value={{ auth, setAuth, persist, setpersist }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;

const defaultAuth = {
    token: '',
    firstname: 'Robin',
    role: 1,
    lastname: 'Yzewyn',
    access_token: '',
    clientcode: '',
    id: 1,
    language: 'N',
    lastlogin: '',
    partner: '',
    relnr: '',
    username: 'robin@qastan.be',
    right: {
        id:                       1,
        userid:                   1,
        username:                 '',
        order:                    true,
        announce:                 true,
        ttdelivery:               true,
        ttcollection:             true,
        ttsafepoint:              true,
        ttatm2t:                  true,
        ttatme2e:                 true,
        ttstops:                  true,
        edoc:                     true,
        complaint:                true,
        requestresearch:          true,
        consumables:              true,
        privatetransport:         true,
        quoteprivatetransport:    true,
        foreign:                  true,
        links:                    true,
        export:                   true,
        message:                  true,
        question:                 true,
        news:                     true,
        faq:                      true,
        regnewuser:               true,
        deleteuser:               true,
        manageusrprofile:         true,
        userlist:                 true,
        log:                      true,
        sipassets:                true,
        sipexecutedinterventions: true,
        sipmanagements:           true,
        sipplanninginterventions: true,
        adminedit:                true,
        pension:                  true,
        transportrequest:         true,
        transportcancel:          true,
    }
}